export function scrollTo() {
    let correction = 100;
    $(".anchor-link").on("click", function (event) {
        event.preventDefault();
        correction = (window.innerWidth >= 1200) ? 180 : 100;
        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - correction
        }, 700);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to.js